(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("CAAS_AOLCOM", [], factory);
	else if(typeof exports === 'object')
		exports["CAAS_AOLCOM"] = factory();
	else
		root["CAAS_AOLCOM"] = factory();
})(self, function() {
return 